import React from "react";
import { ProducerPurchaseOrdersFilterInput } from "@apollo/ops";
import { Controller, useForm } from "react-hook-form";
import { Button } from "@ui/Button";
import { AllProducersAutocomplete } from "@components/Producer/ProducerAutocomplete/ProducerAutocomplete";
import { RegionsDropdown } from "@components/Region/RegionsDropdown";

export type FilterData = ProducerPurchaseOrdersFilterInput;

type AdminPurchaseOrdersFilterProps = {
  onFilter: (data: FilterData) => void | Promise<void>;
  defaultValues?: Partial<FilterData>;
  submitText?: string;
};

export function AdminPurchaseOrdersFilter({
  onFilter,
  defaultValues,
}: AdminPurchaseOrdersFilterProps) {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
  } = useForm<FilterData>({
    defaultValues,
  });

  const wrappedOnSubmit = async (data: FilterData) => {
    try {
      await onFilter(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(wrappedOnSubmit)} autoComplete="off">
      <div className="grid laptop:grid-cols-3 gap-3 items-end">
        <div>
          <Controller
            name="producerId"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <AllProducersAutocomplete
                label="From"
                onSelect={onChange}
                onBlur={onBlur}
                selectedId={value}
                error={errors.producerId?.message}
              />
            )}
          />
        </div>
        <div>
          <Controller
            name="regionId"
            control={control}
            render={({ field: { onChange, value } }) => (
              <RegionsDropdown onChange={onChange} value={value} />
            )}
          />
        </div>
        <div>
          <Button type="submit" disabled={isSubmitting} kind="secondary">
            Filter
          </Button>
        </div>
      </div>
    </form>
  );
}
